export const padWithZero = number => (number !== 0 && number < 10 ? `0${number}` : number);
